import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement } from "react";

const AddShopBtn = (props: any): ReactElement => {
  return (
    <div className="search-box-shadow add-search-box-shadow">
      <Button
        {...props}
        className={"add-btn"}
        type="danger"
        // shape="round"
        icon={<PlusOutlined />}
        size={"large"}
        ghost
        style={{ borderColor: "#faad14", background: 'white' }}
      >
        Create
      </Button>
    </div>
  );
};
AddShopBtn.propTypes = {
  onClick: PropTypes.func,
};

export default AddShopBtn;
